import type React from 'react';

import { type DialogProps } from '@mui/material';

import TMXDialog from 'components/dialogs/TMXDialog';
import { useStyles } from 'components/overlays/styles';
import { BACKGROUND_GREY } from 'theme/colors';

const TMXOverlay: React.FC<
  React.PropsWithChildren<
    DialogProps & {
      TransitionProps?: {
        onEntered?: () => Promise<void> | void;
      };
    }
  >
> = ({ children, ...props }) => {
  const { classes } = useStyles();
  const cssClass = props.className ? `${props.className} ${classes.overlayWrapper}` : classes.overlayWrapper;
  const paperProps = props.PaperProps || { style: { backgroundColor: BACKGROUND_GREY, padding: 10 } };

  return (
    <TMXDialog {...props} className={cssClass} PaperProps={paperProps}>
      {children}
    </TMXDialog>
  );
};

export default TMXOverlay;
